import React from "react";
/** Theme selector */
import {
  ThemeBar,
  changeTheme
} from "../components/ThemeSelector/themeSelector";

interface IndexProps {
  className?: string;
  path?: any;
}

/** Current theme stored in local storage */
const theme = localStorage.currentTheme || "Default";
changeTheme(theme);

const Index = ({ path, className }: IndexProps) => {
  const Page = React.lazy(() => import(`../../docs/${path}`));
  return (
    <React.Suspense fallback={<p>Loading...</p>}>
      <ThemeBar theme={theme} />
      <Page className={className} />
    </React.Suspense>
  );
};

export default Index;
